import apiSlice from '../api/api.slice';
import {
  IDownloadLogsResponse,
  IGetDownloadLogsRequest,
} from './downloadLog.d';

const downloadLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDownloadLogs: builder.query<
      IDownloadLogsResponse,
      IGetDownloadLogsRequest
    >({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/api/v1/downloadLog?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      transformResponse: (response: IDownloadLogsResponse) => response,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['DownloadLog'],
  endpoints: {
    getDownloadLogs: {
      providesTags: ['DownloadLog'],
    },
  },
});

export const { useGetDownloadLogsQuery } = downloadLogApiSlice;
